export default function normalizeUrl(url: string): string {
  // If it already has a protocol, return as-is
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }

  // If it starts with "/", it's a relative URL, return as-is
  if (url.startsWith("/")) {
    return url;
  }

  // Otherwise, it's likely an external URL without a protocol, prepend https://
  return `https://${url}`;
}
